import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const STATUS_COLORS = {
	loading: { background: "#fff4d6", color: "#855f00", border: "#efd79b" },
	ready: { background: "#e7f4ec", color: "#1d5b38", border: "#bad8c5" },
	idle: { background: "#edf1ef", color: "#54635d", border: "#d3ddda" },
	error: { background: "#fdeceb", color: "#a63c32", border: "#f2c2bc" },
};

const getStatusLabel = (status) => {
	if (status === "ready") return "Ready";
	if (status === "error") return "Error";
	if (status === "loading") return "Loading";
	return "Idle";
};

const MapLoadingPanel = ({ stages }) => (
	<Paper
		elevation={0}
		sx={{
			position: "absolute",
			top: 16,
			right: 16,
			zIndex: 1200,
			p: 1.5,
			minWidth: 230,
			borderRadius: 3,
			background: "rgba(255,255,255,0.94)",
			border: "1px solid rgba(53,87,126,0.12)",
			backdropFilter: "blur(8px)",
			pointerEvents: "none",
		}}>
		<Stack spacing={1}>
			<Typography sx={{ fontSize: 12, fontWeight: 700, color: "#294b68", letterSpacing: 0.4, textTransform: "uppercase" }}>
				Map Loading
			</Typography>
			{stages.map((stage) => {
				const statusStyle = STATUS_COLORS[stage.status] ?? STATUS_COLORS.idle;

				return (
					<Stack key={stage.key} direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
						<Typography sx={{ fontSize: 13, color: "#546678" }}>{stage.label}</Typography>
						<Chip
							label={getStatusLabel(stage.status)}
							size="small"
							sx={{
								background: statusStyle.background,
								color: statusStyle.color,
								border: `1px solid ${statusStyle.border}`,
								fontWeight: 700,
							}}
						/>
					</Stack>
				);
			})}
		</Stack>
	</Paper>
);

export default MapLoadingPanel;
